import { createContext, useState, useTransition, useCallback } from 'react';

export const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('alfa-theme') || 'light'
  );
  const [, startTransition] = useTransition();

  const toggleTheme = useCallback(() => {
    // Applica la classe .dark subito, in modo sincrono, senza aspettare React
    const isDark = document.documentElement.classList.toggle('dark');
    localStorage.setItem('alfa-theme', isDark ? 'dark' : 'light');
    // Il re-render React (consumatori del context) è secondario: lo deferiamo
    startTransition(() => setTheme(isDark ? 'dark' : 'light'));
  }, [startTransition]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
